/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdminOrganizerBalanceListItemDtoOrganizer } from './adminOrganizerBalanceListItemDtoOrganizer';


export interface AdminOrganizerBalanceListItemDto { 
    /**
     * Organizer user id
     */
    organizerId: string;
    organizer: AdminOrganizerBalanceListItemDtoOrganizer;
    /**
     * Incoming earnings in cents (from events with payoutStatus incoming/in_escrow)
     */
    incomingEarnings: number;
    /**
     * Number of events contributing to incomingEarnings (count of events with payoutStatus incoming/in_escrow)
     */
    incomingEventsCount: number;
    /**
     * Available amount in cents (from events with payoutStatus available)
     */
    availableAmount: number;
    /**
     * Pending payout amount in cents (withdrawal requested, waiting for Stripe)
     */
    pendingPayoutAmount: number;
    /**
     * Stripe Connect wallet status
     */
    stripeConnectedStatus: AdminOrganizerBalanceListItemDto.StripeConnectedStatusEnum;
}
export namespace AdminOrganizerBalanceListItemDto {
    export type StripeConnectedStatusEnum = 'connected' | 'not-started' | 'access-revoked';
    export const StripeConnectedStatusEnum = {
        Connected: 'connected' as StripeConnectedStatusEnum,
        NotStarted: 'not-started' as StripeConnectedStatusEnum,
        AccessRevoked: 'access-revoked' as StripeConnectedStatusEnum
    };
}


